import React, { useEffect } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPostulacion } from "../components/BannerPostulacion";
import { Footer } from "../../../components/Landing/Footer";
// styled components
import { Button, Radio} from "antd";
// hooks
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { useAgregarParticipante } from "../../../hooks/useAgregarParticipante";
import { FormAgregarParticipante } from "./components/FormAgregarParticipante";
import { useNavigate } from "react-router-dom";

export const AgregarParticipante = () => {
  const { convocatoria, getConvocatoria } = UseVerConvocatorias();
  const navigate = useNavigate();
  const { añadirparticipante, cambiarestadoAñadirparticipante, continuar } =
    useAgregarParticipante();
  useEffect(() => {
    getConvocatoria();
  }, []);
  return (
    <div>
      <Header />
      <BannerPostulacion convocatorias={convocatoria} />
      <div className="container-fluid2">
      <div className="row mt-4">
        <div className="no-margin font-family-Montserrat-Regular font-size-18px">
          <span className="font-family-Montserrat-SemiBold">
            ¡GENIAL! Estás a punto de postularte en la convocatoria. 
          </span>
        </div>
      </div>
      {/* <div className="col-12 mt-4">
          <div className="row">
            <div className="col-2 font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion">2</div>
            <div
              className="col font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
              Participantes
            </div>
          </div>
        </div> */}



            <div
              className="col-12 mt-4 ps-md-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion2">
              Participantes
            </div>


      <div className="row mt-4">
        <div className="col-12">¿Desea añadir un participante?</div>
        <div className="col-12">
          <Radio.Group value={añadirparticipante} onChange={cambiarestadoAñadirparticipante}>
            <Radio value={true}>Sí</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </div>
      </div>
      {añadirparticipante ? (
        <div className="row">
          <FormAgregarParticipante convocatorias={convocatoria}/>
        </div>
      ) : null}
      <div className="bg-white pe-0"
        style={{
          width: "100%",
          justifyContent: "center",
          position: "sticky",
          bottom: 0,
          background: "#FFF",
        }}
      >
        <div className="justify-content-flex-end">
          <Button onClick={() => { navigate(-1) }} style={{ marginRight: "1%" }} type="link" className="button-blanco-radius font-size-12px">
            Atrás
          </Button>
          <Button type="link" className="button-azul-radius font-size-12px" onClick={continuar}>
            Continuar
          </Button>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
};
